<template>
  <div class="single-page search-page" id="search-page">
    <PageHeader />
    <FilteredPostsList
      filters
      taxonomy="postTypes"
      postType="postTypes"
      search
      searchPlaceholder="Søk på nettsiden"
      key="search-filters"
    />
  </div>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";

export default {
  name: "search",
  components: {
    FilteredPostsList
  }
};
</script>
